import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';
import { desktopTechnicals } from '../../../utils/constants/coreTechnicalConstants';
import { useStyles } from './style';
import { useHistory, Link } from 'react-router-dom';

function Desktop(props) {
  const classes = useStyles();
  const history = useHistory();

  const onNavigationHandler = (path) => {
    history.push(path);
  };

  return (
    <Container className={classes.container} maxWidth={false}>
      {desktopTechnicals.map((item, index) => (
        <Link key={index} className={classes.linkText} to={`/developers/${item.name}`}>
          <Box key={index} className={classes.box}>
            <img src={item.img} alt="" className={classes.img}></img>
            <Typography>{item.name}</Typography>
          </Box>
        </Link>
      ))}
    </Container>
  );
}

export default Desktop;
